import Component from '@glimmer/component';
export default class MatchScore extends Component {
  get currentScore() {
    const victories = this.args.rounds.map((round) => {
      return round?.victor?.slug;
    });

    let teamAScore = 0;
    let teamBScore = 0;

    victories.forEach((victor) => {
      if (victor === this.args.teamA.slug) {
        teamAScore++;
      } else if (victor === this.args.teamB.slug) {
        teamBScore++;
      }
    });

    return { a: teamAScore, b: teamBScore };
  }
  <template>
    {{this.currentScore.a}} - {{this.currentScore.b}}
  </template>
}
